import { CheckIcon, CheckIcon2, InfoIcon } from "assets/icons";
import Modal from "components/Modal";
import SpinLoader from "components/SpinLoader";
import { useState } from "react";

function PaymentProcessModal({ open, setOpen, ...rest }) {
  const [status, setStatus] = useState("loading");

  return (
    <Modal open={open} setOpen={setOpen} {...rest}>
      <div className="w-full flex flex-col items-center justify-center py-16 sm:py-20 px-10 sm:px-12 min-h-[400px] md:min-h-[500px]">
        {status === "loading" ? (
          <>
            <img src="/images/logo.jpeg" alt="logo" className="h-12" />
            <div className="py-16">
              <SpinLoader />
            </div>
            <div className="text-base sm:text-lg text-center font-semibold text-black">
              Payment Transactions is processing...
            </div>
          </>
        ) : status === "success" ? (
          <>
            <div className=" mb-12">
              <CheckIcon2 />
            </div>
            <div className="text-base sm:text-lg text-black font-bold mb-2">
              Payment Successful
            </div>
            <div className="max-w-[360px] text-sm text-black text-center mb-12">
              Your payment has been successfully processed. Thank you for
              choosing Maraliner.
            </div>
            <button className="w-full max-w-[300px] h-[48px] bg-primary-700 flex items-center justify-center rounded-[4px] text-sm font-semibold text-white">
              Close
            </button>
          </>
        ) : status === "un-success" ? (
          <>
            <div className=" mb-12">
              <InfoIcon />
            </div>
            <div className="text-base sm:text-lg text-black font-bold mb-2">
              Payment Unsuccessful
            </div>
            <div className="max-w-[360px] text-sm text-black text-center mb-12">
              Unfortunately, your payment could not be processed at this time.
              Please check your payment details and try again.
            </div>
            <button className="w-full max-w-[300px] h-[48px] bg-primary-700 flex items-center justify-center rounded-[4px] text-sm font-semibold text-white">
              Please, try again
            </button>
          </>
        ) : status === "confirmed" ? (
          <>
            <div className="mb-10">
              <img src="/images/pass.png" className="h-[80px]" />
            </div>
            <div className="text-base sm:text-lg text-black font-bold mb-2">
              Booking Confirmed!
            </div>
            <div className="max-w-[360px] text-sm text-center text-black text-center mb-12">
              Congratulation! your bus ticket is confirmed. For more details
              check the my ticket tab.
            </div>
            <button className="w-full max-w-[300px] h-[48px] bg-primary-700 flex items-center justify-center rounded-[4px] text-sm font-semibold text-white">
              My Ticket
            </button>
            <button className="text-sm font-semibold text-black text-center py-4">
              Back to Home
            </button>
          </>
        ) : (
          <></>
        )}
      </div>
    </Modal>
  );
}

export default PaymentProcessModal;
